// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yt-1";
export var printerIcon = "_yt-0";